import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import "./PasswordInput.css";

export default function PasswordInput({ className = "", ...props }) {
  const [shown, setShown] = useState(false);
  return (
    <span className={`password-field ${className}`.trim()}>
      <input {...props} type={shown ? "text" : "password"} autoCapitalize="off" spellCheck={false} />
      <button
        type="button"
        className="password-toggle"
        onClick={() => setShown((value) => !value)}
        onMouseDown={(event) => event.preventDefault()}
        aria-label={shown ? "Hide password" : "Show password"}
        aria-pressed={shown}
        title={shown ? "Hide password" : "Show password"}
      >
        {shown ? <EyeOff size={18} strokeWidth={1.8} aria-hidden="true" /> : <Eye size={18} strokeWidth={1.8} aria-hidden="true" />}
      </button>
    </span>
  );
}
